<template>
  <modal name="editOrderDetails">
    <template #title>
      Order Type
    </template>

    <template #default="{ data }">
      <cf-edit-order-address-details
        :override-fulfillment-type="data.fulfillmentType"
        :edit-success-callback-handler="data.editSuccessCallbackHandler"
      />
    </template>
  </modal>
</template>


<script>
  import CfEditOrderAddressDetails from './cf-edit-order-address-details/index.vue';


  export default {
    name: 'CfEditOrderAddressDetailsModal',

    components: {
      CfEditOrderAddressDetails
    }
  };
</script>
